export const MEDIIIA_CONTEXT_PATHS: Record<string, string> = {
    historymediiia: "/history",
    profmediiia: "/work",
    cinemediiia: "/cine",
    aimediiia: "/ai",
    eventmediiia: "/365",
    musicmediiia: "/sound",
    storiesmediiia: "/stories",
    naturemediiia: "/astro",
    booksmediiia: "/books",
    designmediiia: "/design",
    artmediiia: "/art",
    fairmediiia: "/fair",
    admediiia: "/advert",
    kiiidsmediiia: "/kiiids",
    foodmediiia: "/food",
    automediiia: "/auto",
    conceptmediiia: "/concept",
};

export const CONTEXT_ROUTE_ALIASES: Record<string, string[]> = {
    lmsmediiia: ["education"],
    sportmediiia: ["sport"],
    mymediiia: ["my"],
    urbanmediiia: ["urban"],
    fashion: ["fashion"],
    game: ["game"],
    brnd: ["brands"],
    prof: ["work"],
    academy: ["creativecity"],
    creativecityacademy: ["creativecity"],
};

export const CONTEXT_SHOWCASE_PREFIXES: Record<string, string> = {
    main: "deziiign",
    fashion: "fashiondeziiign",
    game: "gamedeziiign",
    urbanmediiia: "urbandeziiign",
    lmsmediiia: "educationmediiia",
    brnd: "brnd",
    academy: "institutions",
    artmediiia: "mediiiaart",
    admediiia: "mediiiaad",
    kiiidsmediiia: "mediiiakiiids",
    historymediiia: "mediiiahistory",
    booksmediiia: "mediiiabooks",
    sportmediiia: "mediiasport",
    eventmediiia: "mediiia365",
    naturemediiia: "mediiiaastro",
    aimediiia: "mediiiaai",
    musicmediiia: "mediiasound",
    cinemediiia: "mediiiacine",
    foodmediiia: "mediiiafood",
    automediiia: "automediiia",
    conceptmediiia: "mediiiaconcept",
    profmediiia: "mediiiaprof",
    storiesmediiia: "mediiiastories",
    mymediiia: "mymediiia",
};

export const getMediiiaContextPath = (contextName: string): string =>
    MEDIIIA_CONTEXT_PATHS[contextName] ?? "";

export const getShowcaseContextPrefix = (contextName: string): string | undefined =>
    CONTEXT_SHOWCASE_PREFIXES[contextName];

export const isDeziiignMainApplication = (application: string): boolean =>
    application === "deziiign/main" || application === "deziiign";

export const getHostContextKey = (hostname: string): string => {
    const firstLabel = hostname.replace(/^www\./, "").split(".")[0] ?? "";
    const hyphenIndex = firstLabel.indexOf("-");

    if (hyphenIndex > 0) {
        return firstLabel.slice(0, hyphenIndex);
    }

    return firstLabel;
};

export const expandContextKeysForRouteMatch = (keys: string[]): string[] => {
    const expanded = new Set(keys);

    keys.forEach((key) => {
        CONTEXT_ROUTE_ALIASES[key]?.forEach((alias) => expanded.add(alias));

        if (key.endsWith("mediiia")) {
            expanded.add(key.replace(/mediiia$/, ""));
        }

        const mediiiaPath = MEDIIIA_CONTEXT_PATHS[key];
        if (mediiiaPath) {
            expanded.add(mediiiaPath.replace(/^\//, ""));
        }
    });

    return Array.from(expanded).filter(Boolean);
};

type CollectContextKeysParams = {
    contextName: string;
    application?: string;
    pathname?: string;
    storedCtx?: string | null;
};

export const collectApplicationContextKeys = ({
    contextName,
    application = "",
    pathname = "",
    storedCtx = null,
}: CollectContextKeysParams): string[] => {
    const keys = new Set<string>();

    keys.add(contextName);

    if (storedCtx) {
        keys.add(storedCtx);
    }

    const appContext = application.split("/")[1];
    if (appContext) {
        keys.add(appContext);
    }

    if (contextName.endsWith("mediiia")) {
        keys.add(contextName.replace(/mediiia$/, ""));
    }

    const mediiiaPath = MEDIIIA_CONTEXT_PATHS[contextName];
    if (mediiiaPath) {
        keys.add(mediiiaPath.replace(/^\//, ""));
    }

    const pathParts = pathname.replace(/^\//, "").split("/").filter(Boolean);
    const pathSegment = pathParts[0] ?? "";
    if (pathSegment && pathSegment !== "team-create") {
        keys.add(pathSegment);
    }

    return Array.from(keys).filter((key) => key && key !== "main");
};
export const MEDIIIA_CONTEXT_PATHS: Record<string, string> = {
    historymediiia: "/history",
    profmediiia: "/work",
    cinemediiia: "/cine",
    aimediiia: "/ai",
    eventmediiia: "/365",
    musicmediiia: "/sound",
    storiesmediiia: "/stories",
    naturemediiia: "/astro",
    booksmediiia: "/books",
    designmediiia: "/design",
    artmediiia: "/art",
    fairmediiia: "/fair",
    admediiia: "/advert",
    kiiidsmediiia: "/kiiids",
    foodmediiia: "/food",
    automediiia: "/auto",
    conceptmediiia: "/concept",
};

export const CONTEXT_ROUTE_ALIASES: Record<string, string[]> = {
    lmsmediiia: ["education"],
    sportmediiia: ["sport"],
    mymediiia: ["my"],
    urbanmediiia: ["urban"],
    fashion: ["fashion"],
    game: ["game"],
    brnd: ["brands"],
    prof: ["work"],
    academy: ["creativecity"],
    creativecityacademy: ["creativecity"],
};

export const CONTEXT_SHOWCASE_PREFIXES: Record<string, string> = {
    main: "deziiign",
    fashion: "fashiondeziiign",
    game: "gamedeziiign",
    urbanmediiia: "urbandeziiign",
    lmsmediiia: "educationmediiia",
    brnd: "brnd",
    academy: "institutions",
    artmediiia: "mediiiaart",
    admediiia: "mediiiaad",
    kiiidsmediiia: "mediiiakiiids",
    historymediiia: "mediiiahistory",
    booksmediiia: "mediiiabooks",
    sportmediiia: "mediiasport",
    eventmediiia: "mediiia365",
    naturemediiia: "mediiiaastro",
    aimediiia: "mediiiaai",
    musicmediiia: "mediiasound",
    cinemediiia: "mediiiacine",
    foodmediiia: "mediiiafood",
    automediiia: "automediiia",
    conceptmediiia: "mediiiaconcept",
    profmediiia: "mediiiaprof",
    storiesmediiia: "mediiiastories",
    mymediiia: "mymediiia",
};

export const getMediiiaContextPath = (contextName: string): string =>
    MEDIIIA_CONTEXT_PATHS[contextName] ?? "";

export const getShowcaseContextPrefix = (contextName: string): string | undefined =>
    CONTEXT_SHOWCASE_PREFIXES[contextName];

export const isDeziiignMainApplication = (application: string): boolean =>
    application === "deziiign/main" || application === "deziiign";

export const getHostContextKey = (hostname: string): string => {
    const firstLabel = hostname.replace(/^www\./, "").split(".")[0] ?? "";
    const hyphenIndex = firstLabel.indexOf("-");

    if (hyphenIndex > 0) {
        return firstLabel.slice(0, hyphenIndex);
    }

    return firstLabel;
};

export const expandContextKeysForRouteMatch = (keys: string[]): string[] => {
    const expanded = new Set(keys);

    keys.forEach((key) => {
        CONTEXT_ROUTE_ALIASES[key]?.forEach((alias) => expanded.add(alias));

        if (key.endsWith("mediiia")) {
            expanded.add(key.replace(/mediiia$/, ""));
        }

        const mediiiaPath = MEDIIIA_CONTEXT_PATHS[key];
        if (mediiiaPath) {
            expanded.add(mediiiaPath.replace(/^\//, ""));
        }
    });

    return Array.from(expanded).filter(Boolean);
};

type CollectContextKeysParams = {
    contextName: string;
    application?: string;
    pathname?: string;
    storedCtx?: string | null;
};

export const collectApplicationContextKeys = ({
    contextName,
    application = "",
    pathname = "",
    storedCtx = null,
}: CollectContextKeysParams): string[] => {
    const keys = new Set<string>();

    keys.add(contextName);

    if (storedCtx) {
        keys.add(storedCtx);
    }

    const appContext = application.split("/")[1];
    if (appContext) {
        keys.add(appContext);
    }

    if (contextName.endsWith("mediiia")) {
        keys.add(contextName.replace(/mediiia$/, ""));
    }

    const mediiiaPath = MEDIIIA_CONTEXT_PATHS[contextName];
    if (mediiiaPath) {
        keys.add(mediiiaPath.replace(/^\//, ""));
    }

    const pathParts = pathname.replace(/^\//, "").split("/").filter(Boolean);
    const pathSegment = pathParts[0] ?? "";
    if (pathSegment && pathSegment !== "team-create") {
        keys.add(pathSegment);
    }

    return Array.from(keys).filter((key) => key && key !== "main");
};
